module.exports = {
      id: "share-telegram-usage",
      viewBox: "0 0 42 42",
      url: __webpack_public_path__ + "svg-sprite-afa9d3605aa6d2fee8793cc86cfa3445.svg#share-telegram",
      toString: function () {
        return this.url;
      }
    }